import { ThemeProvider } from '@mui/material/styles';
import theme from './CustomTheme';
// @ts-ignore
import React from 'react';
import ConfiguratorScreen from './Screens/ConfiguratorScreen';
import { init } from './configuration';
import { store } from './store';
import { Provider } from 'react-redux';
import { ContainerPositionProvider } from './Components/ContainerPositionProvider';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';

function App() {
  init();
  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ContainerPositionProvider>
            <ConfiguratorScreen />
          </ContainerPositionProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
}

export default App;
